export default __webpack_public_path__ + "static/media/diet-snacking-green.7452a3b5.svg";